<template>
    <div id="app">
        <keep-alive>
            <router-view />
        </keep-alive>
    </div>
</template>

<script>
    // import { getDelQKeyUrl, parseQueryParams } from '@/utils/url';
    // import { getUserInfo } from '@/api/user';
    // import wxMix from '@/mixins/global/wxMixins';

    export default {
        data() {
            return {};
        },
        // mixins: [wxMix],
        created() {
            // this.tryGetUserInfo();
            this.mixInitWxSdk();
        },
        methods: {
            // 尝试获取用户信息(通过微信的code)
            // async tryGetUserInfo() {
            //     const q = parseQueryParams(location.href);
            //     console.log('尝试获取用户信息 q', q);
            //     if (q.code) {
            //         const sendData = {
            //             code: q.code,
            //         };
            //         try {
            //             const resData = await getUserInfo(sendData);
            //             console.log('尝试获取用户信息 resData', resData);
            //             this.$store.commit('setAny', resData);
            //         } catch (e) {
            //             // 大概是code解析失败
            //             this.$dialog
            //                 .confirm({
            //                     title: '错误',
            //                     message: '微信登录失败, 是否重新尝试',
            //                 })
            //                 .then(() => {
            //                     const url = getDelQKeyUrl(location.href);
            //                     location.href = url;
            //                 });
            //         }
            //     }
            // },
        },
    };
</script>

<style lang="scss">
    #app {
        // pass
    }
</style>
